import React from "react";
import ForgotPassword from "./Component";

const Container = () => {
  return <ForgotPassword />;
};

export default Container;
